import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import './style.scss'
const ImageMailHero = () => {

    const data = useStaticQuery(graphql`
    query ImageMailHero {
        file(relativePath: {eq: "mail_hero.png"}) {
          
          childImageSharp {
            gatsbyImageData(placeholder: NONE)
          }
        }
      }
      
    `);

    const image = getImage(data.file);

    return (
      <GatsbyImage 
      image={image} 
      imgStyle={{ left: '0', width: '100%' }}
                alt="Checkbook image" 
            />
    );
  };

export default ImageMailHero;